import { TableService } from './table-service';
import { Pickup } from '../../../models/pickup';
import { PickupQuery } from '../../../models/pickup-query';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectPickupTableBusy, selectPickupTableCount,
    selectPickupTablePage,
    selectPickupTableQuery,
    selectPickupTableSelection
} from '../../../store/pickup-table/pickup-table.state';
import { PickupColumnEnum } from '../../../enum/pickup-column.enum';
import {
    pickupTableChangePage,
    pickupTableMasterToggle,
    pickupTableSort,
    pickupTableToggle
} from '../../../store/pickup-table/pickup-table.actions';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class PickupTableService extends TableService<Pickup, PickupQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectPickupTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            PickupColumnEnum.PICKUP_REFERENCE,
            PickupColumnEnum.PICKUP_DATE,
            PickupColumnEnum.PICKUP_TIME_START,
            PickupColumnEnum.PICKUP_TIME_END,
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Pickup[]> {
        return this.store.select(selectPickupTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.PICKUP;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectPickupTableSelection);
    }

    protected getTableQueryObservable(): Observable<PickupQuery> {
        return this.store.select(selectPickupTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectPickupTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(pickupTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(pickupTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(pickupTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(pickupTableMasterToggle());
    }

}
